import {
  NavBar,
  HeroSection,
  HomepageVsl,
  ProblemSection,
  SolutionSection,
  HowItWorksSection,
  PricingSection,
  FinalCTASection,
  Footer,
  type HeroCopy,
} from "@/pages/homepage";
import { TestimonialsSection } from "@/components/marketing/social-proof";

// Hero copy for the /meta-trial landing page only. Reframes the offer as a
// "3-Day Local Visibility Diagnostic". Numbers are the real configured values:
// the up-front trial fee is TRIAL_INITIAL_PRICE_USD ($1) and the post-trial
// monthly is the Starter tier (TIER_PRICES_USD.starter = $399), which is the
// entry tier the paid trial rolls into.
export const META_TRIAL_HERO: HeroCopy = {
  headline: "Get your 3-Day Local Visibility Diagnostic for $1",
  subhead:
    "See exactly where your business ranks on Google Maps, in ChatGPT, and in AI search — in 60 seconds.",
  ctaLabel: "Run my $1 diagnostic",
  priceLine: "$1 for 3 days, then $399/mo unless you cancel — cancel in one click.",
  whatYouGet: [
    "A full Google Business Profile + AI-search audit",
    "A prioritized fix checklist",
    "An estimate of the revenue you're missing",
  ],
};

// The $1-trial landing page. Mirrors the homepage layout so it converts the
// same way, but pulls the video testimonials up near the top (right under the
// hero VSL) so paid traffic sees real proof immediately. Lead-source
// attribution is stashed by <TrialLanding /> in App.tsx before this renders;
// every "$1 trial" CTA funnels into the existing /login → Google sign-in flow.
// `heroProps` lets a specific route (e.g. /meta-trial) override the hero copy
// without affecting the shared homepage or the other trial pages.
export default function TrialLandingPage({ heroProps }: { heroProps?: HeroCopy }) {
  return (
    <div className="min-h-screen bg-[#0A0A0F] text-white">
      <NavBar />
      <HeroSection {...heroProps} />
      <HomepageVsl />
      <TestimonialsSection />
      <ProblemSection />
      <SolutionSection />
      <HowItWorksSection />
      <PricingSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
}
